import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SiteDashboardComponent } from '../../shared/components/site-dashboard/site-dashboard';

@Component({
  selector: 'app-digital-signage',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SiteDashboardComponent
  ],
  templateUrl: './digital-signage.html',
  styleUrl: './digital-signage.scss',
})
export class DigitalSignageComponent {}
